/** Methods to use when ordering `Activity`. */
export var ActivitiesOrderBy;
(function (ActivitiesOrderBy) {
    ActivitiesOrderBy["ActionUrlAsc"] = "ACTION_URL_ASC";
    ActivitiesOrderBy["ActionUrlDesc"] = "ACTION_URL_DESC";
    ActivitiesOrderBy["ActorIdAsc"] = "ACTOR_ID_ASC";
    ActivitiesOrderBy["ActorIdDesc"] = "ACTOR_ID_DESC";
    ActivitiesOrderBy["ButtonLabelAsc"] = "BUTTON_LABEL_ASC";
    ActivitiesOrderBy["ButtonLabelDesc"] = "BUTTON_LABEL_DESC";
    ActivitiesOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ActivitiesOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ActivitiesOrderBy["EntityIdAsc"] = "ENTITY_ID_ASC";
    ActivitiesOrderBy["EntityIdDesc"] = "ENTITY_ID_DESC";
    ActivitiesOrderBy["EntityTypeAsc"] = "ENTITY_TYPE_ASC";
    ActivitiesOrderBy["EntityTypeDesc"] = "ENTITY_TYPE_DESC";
    ActivitiesOrderBy["EventAsc"] = "EVENT_ASC";
    ActivitiesOrderBy["EventDesc"] = "EVENT_DESC";
    ActivitiesOrderBy["IdAsc"] = "ID_ASC";
    ActivitiesOrderBy["IdDesc"] = "ID_DESC";
    ActivitiesOrderBy["MetadataAsc"] = "METADATA_ASC";
    ActivitiesOrderBy["MetadataDesc"] = "METADATA_DESC";
    ActivitiesOrderBy["Natural"] = "NATURAL";
    ActivitiesOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ActivitiesOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ActivitiesOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ActivitiesOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ActivitiesOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    ActivitiesOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
    ActivitiesOrderBy["SummaryAsc"] = "SUMMARY_ASC";
    ActivitiesOrderBy["SummaryDesc"] = "SUMMARY_DESC";
})(ActivitiesOrderBy || (ActivitiesOrderBy = {}));
/** Methods to use when ordering `Agent`. */
export var AgentsOrderBy;
(function (AgentsOrderBy) {
    AgentsOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    AgentsOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    AgentsOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    AgentsOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    AgentsOrderBy["ConfigAsc"] = "CONFIG_ASC";
    AgentsOrderBy["ConfigDesc"] = "CONFIG_DESC";
    AgentsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    AgentsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    AgentsOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    AgentsOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    AgentsOrderBy["DescriptionAsc"] = "DESCRIPTION_ASC";
    AgentsOrderBy["DescriptionDesc"] = "DESCRIPTION_DESC";
    AgentsOrderBy["ElAgentIdAsc"] = "EL_AGENT_ID_ASC";
    AgentsOrderBy["ElAgentIdDesc"] = "EL_AGENT_ID_DESC";
    AgentsOrderBy["FlowAsc"] = "FLOW_ASC";
    AgentsOrderBy["FlowDesc"] = "FLOW_DESC";
    AgentsOrderBy["FlowMetaAsc"] = "FLOW_META_ASC";
    AgentsOrderBy["FlowMetaDesc"] = "FLOW_META_DESC";
    AgentsOrderBy["GoalAsc"] = "GOAL_ASC";
    AgentsOrderBy["GoalDesc"] = "GOAL_DESC";
    AgentsOrderBy["GreetingBodyAsc"] = "GREETING_BODY_ASC";
    AgentsOrderBy["GreetingBodyDesc"] = "GREETING_BODY_DESC";
    AgentsOrderBy["GreetingTitleAsc"] = "GREETING_TITLE_ASC";
    AgentsOrderBy["GreetingTitleDesc"] = "GREETING_TITLE_DESC";
    AgentsOrderBy["IdAsc"] = "ID_ASC";
    AgentsOrderBy["IdDesc"] = "ID_DESC";
    AgentsOrderBy["NameAsc"] = "NAME_ASC";
    AgentsOrderBy["NameDesc"] = "NAME_DESC";
    AgentsOrderBy["Natural"] = "NATURAL";
    AgentsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    AgentsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    AgentsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    AgentsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    AgentsOrderBy["PromptAsc"] = "PROMPT_ASC";
    AgentsOrderBy["PromptDesc"] = "PROMPT_DESC";
    AgentsOrderBy["SectionsAsc"] = "SECTIONS_ASC";
    AgentsOrderBy["SectionsDesc"] = "SECTIONS_DESC";
    AgentsOrderBy["TemplateSlugAsc"] = "TEMPLATE_SLUG_ASC";
    AgentsOrderBy["TemplateSlugDesc"] = "TEMPLATE_SLUG_DESC";
    AgentsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    AgentsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(AgentsOrderBy || (AgentsOrderBy = {}));
/** Methods to use when ordering `AssetVersion`. */
export var AssetVersionsOrderBy;
(function (AssetVersionsOrderBy) {
    AssetVersionsOrderBy["AssetIdAsc"] = "ASSET_ID_ASC";
    AssetVersionsOrderBy["AssetIdDesc"] = "ASSET_ID_DESC";
    AssetVersionsOrderBy["ChangeSummaryAsc"] = "CHANGE_SUMMARY_ASC";
    AssetVersionsOrderBy["ChangeSummaryDesc"] = "CHANGE_SUMMARY_DESC";
    AssetVersionsOrderBy["ContentAsc"] = "CONTENT_ASC";
    AssetVersionsOrderBy["ContentDesc"] = "CONTENT_DESC";
    AssetVersionsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    AssetVersionsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    AssetVersionsOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    AssetVersionsOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    AssetVersionsOrderBy["IdAsc"] = "ID_ASC";
    AssetVersionsOrderBy["IdDesc"] = "ID_DESC";
    AssetVersionsOrderBy["MetadataAsc"] = "METADATA_ASC";
    AssetVersionsOrderBy["MetadataDesc"] = "METADATA_DESC";
    AssetVersionsOrderBy["Natural"] = "NATURAL";
    AssetVersionsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    AssetVersionsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    AssetVersionsOrderBy["TitleAsc"] = "TITLE_ASC";
    AssetVersionsOrderBy["TitleDesc"] = "TITLE_DESC";
    AssetVersionsOrderBy["VersionNumberAsc"] = "VERSION_NUMBER_ASC";
    AssetVersionsOrderBy["VersionNumberDesc"] = "VERSION_NUMBER_DESC";
})(AssetVersionsOrderBy || (AssetVersionsOrderBy = {}));
/** Methods to use when ordering `Asset`. */
export var AssetsOrderBy;
(function (AssetsOrderBy) {
    AssetsOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    AssetsOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    AssetsOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    AssetsOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    AssetsOrderBy["AssetTypeAsc"] = "ASSET_TYPE_ASC";
    AssetsOrderBy["AssetTypeDesc"] = "ASSET_TYPE_DESC";
    AssetsOrderBy["ContentAsc"] = "CONTENT_ASC";
    AssetsOrderBy["ContentDesc"] = "CONTENT_DESC";
    AssetsOrderBy["ContentFileUrlAsc"] = "CONTENT_FILE_URL_ASC";
    AssetsOrderBy["ContentFileUrlDesc"] = "CONTENT_FILE_URL_DESC";
    AssetsOrderBy["ConversationIdAsc"] = "CONVERSATION_ID_ASC";
    AssetsOrderBy["ConversationIdDesc"] = "CONVERSATION_ID_DESC";
    AssetsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    AssetsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    AssetsOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    AssetsOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    AssetsOrderBy["CurrentVersionNumberAsc"] = "CURRENT_VERSION_NUMBER_ASC";
    AssetsOrderBy["CurrentVersionNumberDesc"] = "CURRENT_VERSION_NUMBER_DESC";
    AssetsOrderBy["GenerationTemplateDeprecatedAsc"] = "GENERATION_TEMPLATE_DEPRECATED_ASC";
    AssetsOrderBy["GenerationTemplateDeprecatedDesc"] = "GENERATION_TEMPLATE_DEPRECATED_DESC";
    AssetsOrderBy["GenerationTemplateIdAsc"] = "GENERATION_TEMPLATE_ID_ASC";
    AssetsOrderBy["GenerationTemplateIdDesc"] = "GENERATION_TEMPLATE_ID_DESC";
    AssetsOrderBy["IdAsc"] = "ID_ASC";
    AssetsOrderBy["IdDesc"] = "ID_DESC";
    AssetsOrderBy["MetadataAsc"] = "METADATA_ASC";
    AssetsOrderBy["MetadataDesc"] = "METADATA_DESC";
    AssetsOrderBy["Natural"] = "NATURAL";
    AssetsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    AssetsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    AssetsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    AssetsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    AssetsOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    AssetsOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
    AssetsOrderBy["StatusAsc"] = "STATUS_ASC";
    AssetsOrderBy["StatusDesc"] = "STATUS_DESC";
    AssetsOrderBy["TitleAsc"] = "TITLE_ASC";
    AssetsOrderBy["TitleDesc"] = "TITLE_DESC";
    AssetsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    AssetsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(AssetsOrderBy || (AssetsOrderBy = {}));
/** Methods to use when ordering `Connection`. */
export var ConnectionsOrderBy;
(function (ConnectionsOrderBy) {
    ConnectionsOrderBy["AgentIdAsc"] = "AGENT_ID_ASC";
    ConnectionsOrderBy["AgentIdDesc"] = "AGENT_ID_DESC";
    ConnectionsOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    ConnectionsOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    ConnectionsOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    ConnectionsOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    ConnectionsOrderBy["AuthStyleAsc"] = "AUTH_STYLE_ASC";
    ConnectionsOrderBy["AuthStyleDesc"] = "AUTH_STYLE_DESC";
    ConnectionsOrderBy["ConnectionCodeAsc"] = "CONNECTION_CODE_ASC";
    ConnectionsOrderBy["ConnectionCodeDesc"] = "CONNECTION_CODE_DESC";
    ConnectionsOrderBy["ContextAsc"] = "CONTEXT_ASC";
    ConnectionsOrderBy["ContextDesc"] = "CONTEXT_DESC";
    ConnectionsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ConnectionsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ConnectionsOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    ConnectionsOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    ConnectionsOrderBy["ExpiresAtAsc"] = "EXPIRES_AT_ASC";
    ConnectionsOrderBy["ExpiresAtDesc"] = "EXPIRES_AT_DESC";
    ConnectionsOrderBy["GreetingBodyAsc"] = "GREETING_BODY_ASC";
    ConnectionsOrderBy["GreetingBodyDesc"] = "GREETING_BODY_DESC";
    ConnectionsOrderBy["GreetingTitleAsc"] = "GREETING_TITLE_ASC";
    ConnectionsOrderBy["GreetingTitleDesc"] = "GREETING_TITLE_DESC";
    ConnectionsOrderBy["InviteTypeAsc"] = "INVITE_TYPE_ASC";
    ConnectionsOrderBy["InviteTypeDesc"] = "INVITE_TYPE_DESC";
    ConnectionsOrderBy["MaxUsesAsc"] = "MAX_USES_ASC";
    ConnectionsOrderBy["MaxUsesDesc"] = "MAX_USES_DESC";
    ConnectionsOrderBy["MessageAsc"] = "MESSAGE_ASC";
    ConnectionsOrderBy["MessageDesc"] = "MESSAGE_DESC";
    ConnectionsOrderBy["Natural"] = "NATURAL";
    ConnectionsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ConnectionsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ConnectionsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ConnectionsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ConnectionsOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    ConnectionsOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
    ConnectionsOrderBy["RequiresAuthAsc"] = "REQUIRES_AUTH_ASC";
    ConnectionsOrderBy["RequiresAuthDesc"] = "REQUIRES_AUTH_DESC";
    ConnectionsOrderBy["SentAtAsc"] = "SENT_AT_ASC";
    ConnectionsOrderBy["SentAtDesc"] = "SENT_AT_DESC";
    ConnectionsOrderBy["SubjectAsc"] = "SUBJECT_ASC";
    ConnectionsOrderBy["SubjectDesc"] = "SUBJECT_DESC";
    ConnectionsOrderBy["TargetEmailAsc"] = "TARGET_EMAIL_ASC";
    ConnectionsOrderBy["TargetEmailDesc"] = "TARGET_EMAIL_DESC";
    ConnectionsOrderBy["TargetNameAsc"] = "TARGET_NAME_ASC";
    ConnectionsOrderBy["TargetNameDesc"] = "TARGET_NAME_DESC";
    ConnectionsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ConnectionsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(ConnectionsOrderBy || (ConnectionsOrderBy = {}));
/** Methods to use when ordering `Conversation`. */
export var ConversationsOrderBy;
(function (ConversationsOrderBy) {
    ConversationsOrderBy["AgentIdAsc"] = "AGENT_ID_ASC";
    ConversationsOrderBy["AgentIdDesc"] = "AGENT_ID_DESC";
    ConversationsOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    ConversationsOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    ConversationsOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    ConversationsOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    ConversationsOrderBy["CompletedAtAsc"] = "COMPLETED_AT_ASC";
    ConversationsOrderBy["CompletedAtDesc"] = "COMPLETED_AT_DESC";
    ConversationsOrderBy["CompletionScoreAsc"] = "COMPLETION_SCORE_ASC";
    ConversationsOrderBy["CompletionScoreDesc"] = "COMPLETION_SCORE_DESC";
    ConversationsOrderBy["ConnectionCodeAsc"] = "CONNECTION_CODE_ASC";
    ConversationsOrderBy["ConnectionCodeDesc"] = "CONNECTION_CODE_DESC";
    ConversationsOrderBy["ContextAsc"] = "CONTEXT_ASC";
    ConversationsOrderBy["ContextDesc"] = "CONTEXT_DESC";
    ConversationsOrderBy["ConversationAsc"] = "CONVERSATION_ASC";
    ConversationsOrderBy["ConversationDesc"] = "CONVERSATION_DESC";
    ConversationsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ConversationsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ConversationsOrderBy["FlavorAsc"] = "FLAVOR_ASC";
    ConversationsOrderBy["FlavorDesc"] = "FLAVOR_DESC";
    ConversationsOrderBy["IdAsc"] = "ID_ASC";
    ConversationsOrderBy["IdDesc"] = "ID_DESC";
    ConversationsOrderBy["LastActivityAtAsc"] = "LAST_ACTIVITY_AT_ASC";
    ConversationsOrderBy["LastActivityAtDesc"] = "LAST_ACTIVITY_AT_DESC";
    ConversationsOrderBy["Natural"] = "NATURAL";
    ConversationsOrderBy["NetDurationAsc"] = "NET_DURATION_ASC";
    ConversationsOrderBy["NetDurationDesc"] = "NET_DURATION_DESC";
    ConversationsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ConversationsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ConversationsOrderBy["ParticipantUserIdAsc"] = "PARTICIPANT_USER_ID_ASC";
    ConversationsOrderBy["ParticipantUserIdDesc"] = "PARTICIPANT_USER_ID_DESC";
    ConversationsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ConversationsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ConversationsOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    ConversationsOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
    ConversationsOrderBy["QuestionsAsc"] = "QUESTIONS_ASC";
    ConversationsOrderBy["QuestionsDesc"] = "QUESTIONS_DESC";
    ConversationsOrderBy["SessionPropertiesAsc"] = "SESSION_PROPERTIES_ASC";
    ConversationsOrderBy["SessionPropertiesDesc"] = "SESSION_PROPERTIES_DESC";
    ConversationsOrderBy["StartedAtAsc"] = "STARTED_AT_ASC";
    ConversationsOrderBy["StartedAtDesc"] = "STARTED_AT_DESC";
    ConversationsOrderBy["StatusAsc"] = "STATUS_ASC";
    ConversationsOrderBy["StatusDesc"] = "STATUS_DESC";
    ConversationsOrderBy["TurnCountAsc"] = "TURN_COUNT_ASC";
    ConversationsOrderBy["TurnCountDesc"] = "TURN_COUNT_DESC";
    ConversationsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ConversationsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(ConversationsOrderBy || (ConversationsOrderBy = {}));
/** Methods to use when ordering `ConversationsWithProfile`. */
export var ConversationsWithProfilesOrderBy;
(function (ConversationsWithProfilesOrderBy) {
    ConversationsWithProfilesOrderBy["AgentIdAsc"] = "AGENT_ID_ASC";
    ConversationsWithProfilesOrderBy["AgentIdDesc"] = "AGENT_ID_DESC";
    ConversationsWithProfilesOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    ConversationsWithProfilesOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    ConversationsWithProfilesOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    ConversationsWithProfilesOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    ConversationsWithProfilesOrderBy["CompletedAtAsc"] = "COMPLETED_AT_ASC";
    ConversationsWithProfilesOrderBy["CompletedAtDesc"] = "COMPLETED_AT_DESC";
    ConversationsWithProfilesOrderBy["CompletionScoreAsc"] = "COMPLETION_SCORE_ASC";
    ConversationsWithProfilesOrderBy["CompletionScoreDesc"] = "COMPLETION_SCORE_DESC";
    ConversationsWithProfilesOrderBy["ConnectionCodeAsc"] = "CONNECTION_CODE_ASC";
    ConversationsWithProfilesOrderBy["ConnectionCodeDesc"] = "CONNECTION_CODE_DESC";
    ConversationsWithProfilesOrderBy["ContextAsc"] = "CONTEXT_ASC";
    ConversationsWithProfilesOrderBy["ContextDesc"] = "CONTEXT_DESC";
    ConversationsWithProfilesOrderBy["ConversationAsc"] = "CONVERSATION_ASC";
    ConversationsWithProfilesOrderBy["ConversationDesc"] = "CONVERSATION_DESC";
    ConversationsWithProfilesOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ConversationsWithProfilesOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ConversationsWithProfilesOrderBy["IdAsc"] = "ID_ASC";
    ConversationsWithProfilesOrderBy["IdDesc"] = "ID_DESC";
    ConversationsWithProfilesOrderBy["LastActivityAtAsc"] = "LAST_ACTIVITY_AT_ASC";
    ConversationsWithProfilesOrderBy["LastActivityAtDesc"] = "LAST_ACTIVITY_AT_DESC";
    ConversationsWithProfilesOrderBy["Natural"] = "NATURAL";
    ConversationsWithProfilesOrderBy["NetDurationAsc"] = "NET_DURATION_ASC";
    ConversationsWithProfilesOrderBy["NetDurationDesc"] = "NET_DURATION_DESC";
    ConversationsWithProfilesOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ConversationsWithProfilesOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileAvatarImageUrlAsc"] = "PARTICIPANT_PROFILE_AVATAR_IMAGE_URL_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileAvatarImageUrlDesc"] = "PARTICIPANT_PROFILE_AVATAR_IMAGE_URL_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileCreatedAtAsc"] = "PARTICIPANT_PROFILE_CREATED_AT_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileCreatedAtDesc"] = "PARTICIPANT_PROFILE_CREATED_AT_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileEmailAsc"] = "PARTICIPANT_PROFILE_EMAIL_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileEmailDesc"] = "PARTICIPANT_PROFILE_EMAIL_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileFirstNameAsc"] = "PARTICIPANT_PROFILE_FIRST_NAME_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileFirstNameDesc"] = "PARTICIPANT_PROFILE_FIRST_NAME_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileIdAsc"] = "PARTICIPANT_PROFILE_ID_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileIdDesc"] = "PARTICIPANT_PROFILE_ID_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileLastNameAsc"] = "PARTICIPANT_PROFILE_LAST_NAME_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileLastNameDesc"] = "PARTICIPANT_PROFILE_LAST_NAME_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileOrganizationDomainAsc"] = "PARTICIPANT_PROFILE_ORGANIZATION_DOMAIN_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileOrganizationDomainDesc"] = "PARTICIPANT_PROFILE_ORGANIZATION_DOMAIN_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileOrganizationNameAsc"] = "PARTICIPANT_PROFILE_ORGANIZATION_NAME_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileOrganizationNameDesc"] = "PARTICIPANT_PROFILE_ORGANIZATION_NAME_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileUpdatedAtAsc"] = "PARTICIPANT_PROFILE_UPDATED_AT_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileUpdatedAtDesc"] = "PARTICIPANT_PROFILE_UPDATED_AT_DESC";
    ConversationsWithProfilesOrderBy["ParticipantProfileUserIdAsc"] = "PARTICIPANT_PROFILE_USER_ID_ASC";
    ConversationsWithProfilesOrderBy["ParticipantProfileUserIdDesc"] = "PARTICIPANT_PROFILE_USER_ID_DESC";
    ConversationsWithProfilesOrderBy["ParticipantUserIdAsc"] = "PARTICIPANT_USER_ID_ASC";
    ConversationsWithProfilesOrderBy["ParticipantUserIdDesc"] = "PARTICIPANT_USER_ID_DESC";
    ConversationsWithProfilesOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    ConversationsWithProfilesOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
    ConversationsWithProfilesOrderBy["QuestionsAsc"] = "QUESTIONS_ASC";
    ConversationsWithProfilesOrderBy["QuestionsDesc"] = "QUESTIONS_DESC";
    ConversationsWithProfilesOrderBy["SessionPropertiesAsc"] = "SESSION_PROPERTIES_ASC";
    ConversationsWithProfilesOrderBy["SessionPropertiesDesc"] = "SESSION_PROPERTIES_DESC";
    ConversationsWithProfilesOrderBy["StartedAtAsc"] = "STARTED_AT_ASC";
    ConversationsWithProfilesOrderBy["StartedAtDesc"] = "STARTED_AT_DESC";
    ConversationsWithProfilesOrderBy["StatusAsc"] = "STATUS_ASC";
    ConversationsWithProfilesOrderBy["StatusDesc"] = "STATUS_DESC";
    ConversationsWithProfilesOrderBy["TurnCountAsc"] = "TURN_COUNT_ASC";
    ConversationsWithProfilesOrderBy["TurnCountDesc"] = "TURN_COUNT_DESC";
    ConversationsWithProfilesOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ConversationsWithProfilesOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(ConversationsWithProfilesOrderBy || (ConversationsWithProfilesOrderBy = {}));
/** Methods to use when ordering `File`. */
export var FilesOrderBy;
(function (FilesOrderBy) {
    FilesOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    FilesOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    FilesOrderBy["FileSizeAsc"] = "FILE_SIZE_ASC";
    FilesOrderBy["FileSizeDesc"] = "FILE_SIZE_DESC";
    FilesOrderBy["MimeTypeAsc"] = "MIME_TYPE_ASC";
    FilesOrderBy["MimeTypeDesc"] = "MIME_TYPE_DESC";
    FilesOrderBy["Natural"] = "NATURAL";
    FilesOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    FilesOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    FilesOrderBy["OriginalFilenameAsc"] = "ORIGINAL_FILENAME_ASC";
    FilesOrderBy["OriginalFilenameDesc"] = "ORIGINAL_FILENAME_DESC";
    FilesOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    FilesOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    FilesOrderBy["StorageProviderAsc"] = "STORAGE_PROVIDER_ASC";
    FilesOrderBy["StorageProviderDesc"] = "STORAGE_PROVIDER_DESC";
    FilesOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    FilesOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    FilesOrderBy["UploadedByUserIdAsc"] = "UPLOADED_BY_USER_ID_ASC";
    FilesOrderBy["UploadedByUserIdDesc"] = "UPLOADED_BY_USER_ID_DESC";
    FilesOrderBy["UrlAsc"] = "URL_ASC";
    FilesOrderBy["UrlDesc"] = "URL_DESC";
})(FilesOrderBy || (FilesOrderBy = {}));
/** Methods to use when ordering `GenerationTemplate`. */
export var GenerationTemplatesOrderBy;
(function (GenerationTemplatesOrderBy) {
    GenerationTemplatesOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    GenerationTemplatesOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    GenerationTemplatesOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    GenerationTemplatesOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    GenerationTemplatesOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    GenerationTemplatesOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    GenerationTemplatesOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    GenerationTemplatesOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    GenerationTemplatesOrderBy["DescriptionAsc"] = "DESCRIPTION_ASC";
    GenerationTemplatesOrderBy["DescriptionDesc"] = "DESCRIPTION_DESC";
    GenerationTemplatesOrderBy["IdAsc"] = "ID_ASC";
    GenerationTemplatesOrderBy["IdDesc"] = "ID_DESC";
    GenerationTemplatesOrderBy["IsFavoriteAsc"] = "IS_FAVORITE_ASC";
    GenerationTemplatesOrderBy["IsFavoriteDesc"] = "IS_FAVORITE_DESC";
    GenerationTemplatesOrderBy["IsSystemDefaultAsc"] = "IS_SYSTEM_DEFAULT_ASC";
    GenerationTemplatesOrderBy["IsSystemDefaultDesc"] = "IS_SYSTEM_DEFAULT_DESC";
    GenerationTemplatesOrderBy["LastUsedAtAsc"] = "LAST_USED_AT_ASC";
    GenerationTemplatesOrderBy["LastUsedAtDesc"] = "LAST_USED_AT_DESC";
    GenerationTemplatesOrderBy["MetadataAsc"] = "METADATA_ASC";
    GenerationTemplatesOrderBy["MetadataDesc"] = "METADATA_DESC";
    GenerationTemplatesOrderBy["NameAsc"] = "NAME_ASC";
    GenerationTemplatesOrderBy["NameDesc"] = "NAME_DESC";
    GenerationTemplatesOrderBy["Natural"] = "NATURAL";
    GenerationTemplatesOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    GenerationTemplatesOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    GenerationTemplatesOrderBy["ParentTemplateIdAsc"] = "PARENT_TEMPLATE_ID_ASC";
    GenerationTemplatesOrderBy["ParentTemplateIdDesc"] = "PARENT_TEMPLATE_ID_DESC";
    GenerationTemplatesOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    GenerationTemplatesOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    GenerationTemplatesOrderBy["PromptTemplateAsc"] = "PROMPT_TEMPLATE_ASC";
    GenerationTemplatesOrderBy["PromptTemplateDesc"] = "PROMPT_TEMPLATE_DESC";
    GenerationTemplatesOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    GenerationTemplatesOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    GenerationTemplatesOrderBy["UsageCountAsc"] = "USAGE_COUNT_ASC";
    GenerationTemplatesOrderBy["UsageCountDesc"] = "USAGE_COUNT_DESC";
})(GenerationTemplatesOrderBy || (GenerationTemplatesOrderBy = {}));
/** Methods to use when ordering `Notification`. */
export var NotificationsOrderBy;
(function (NotificationsOrderBy) {
    NotificationsOrderBy["ActionLabelAsc"] = "ACTION_LABEL_ASC";
    NotificationsOrderBy["ActionLabelDesc"] = "ACTION_LABEL_DESC";
    NotificationsOrderBy["ActionUrlAsc"] = "ACTION_URL_ASC";
    NotificationsOrderBy["ActionUrlDesc"] = "ACTION_URL_DESC";
    NotificationsOrderBy["AssetIdAsc"] = "ASSET_ID_ASC";
    NotificationsOrderBy["AssetIdDesc"] = "ASSET_ID_DESC";
    NotificationsOrderBy["ClickedAtAsc"] = "CLICKED_AT_ASC";
    NotificationsOrderBy["ClickedAtDesc"] = "CLICKED_AT_DESC";
    NotificationsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    NotificationsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    NotificationsOrderBy["DismissedAtAsc"] = "DISMISSED_AT_ASC";
    NotificationsOrderBy["DismissedAtDesc"] = "DISMISSED_AT_DESC";
    NotificationsOrderBy["EventAsc"] = "EVENT_ASC";
    NotificationsOrderBy["EventDesc"] = "EVENT_DESC";
    NotificationsOrderBy["IdAsc"] = "ID_ASC";
    NotificationsOrderBy["IdDesc"] = "ID_DESC";
    NotificationsOrderBy["InterviewSessionIdAsc"] = "INTERVIEW_SESSION_ID_ASC";
    NotificationsOrderBy["InterviewSessionIdDesc"] = "INTERVIEW_SESSION_ID_DESC";
    NotificationsOrderBy["MessageAsc"] = "MESSAGE_ASC";
    NotificationsOrderBy["MessageDesc"] = "MESSAGE_DESC";
    NotificationsOrderBy["MetadataAsc"] = "METADATA_ASC";
    NotificationsOrderBy["MetadataDesc"] = "METADATA_DESC";
    NotificationsOrderBy["Natural"] = "NATURAL";
    NotificationsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    NotificationsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    NotificationsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    NotificationsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    NotificationsOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    NotificationsOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
    NotificationsOrderBy["ReadAtAsc"] = "READ_AT_ASC";
    NotificationsOrderBy["ReadAtDesc"] = "READ_AT_DESC";
    NotificationsOrderBy["TitleAsc"] = "TITLE_ASC";
    NotificationsOrderBy["TitleDesc"] = "TITLE_DESC";
    NotificationsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    NotificationsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    NotificationsOrderBy["UserIdAsc"] = "USER_ID_ASC";
    NotificationsOrderBy["UserIdDesc"] = "USER_ID_DESC";
})(NotificationsOrderBy || (NotificationsOrderBy = {}));
/** Methods to use when ordering `Offering`. */
export var OfferingsOrderBy;
(function (OfferingsOrderBy) {
    OfferingsOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    OfferingsOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    OfferingsOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    OfferingsOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    OfferingsOrderBy["ContextAsc"] = "CONTEXT_ASC";
    OfferingsOrderBy["ContextDesc"] = "CONTEXT_DESC";
    OfferingsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    OfferingsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    OfferingsOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    OfferingsOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    OfferingsOrderBy["DescriptionAsc"] = "DESCRIPTION_ASC";
    OfferingsOrderBy["DescriptionDesc"] = "DESCRIPTION_DESC";
    OfferingsOrderBy["IdAsc"] = "ID_ASC";
    OfferingsOrderBy["IdDesc"] = "ID_DESC";
    OfferingsOrderBy["NameAsc"] = "NAME_ASC";
    OfferingsOrderBy["NameDesc"] = "NAME_DESC";
    OfferingsOrderBy["Natural"] = "NATURAL";
    OfferingsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    OfferingsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    OfferingsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    OfferingsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    OfferingsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    OfferingsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(OfferingsOrderBy || (OfferingsOrderBy = {}));
/** Methods to use when ordering `OrganizationInvite`. */
export var OrganizationInvitesOrderBy;
(function (OrganizationInvitesOrderBy) {
    OrganizationInvitesOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    OrganizationInvitesOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    OrganizationInvitesOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    OrganizationInvitesOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    OrganizationInvitesOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    OrganizationInvitesOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    OrganizationInvitesOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    OrganizationInvitesOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    OrganizationInvitesOrderBy["ExpiresAtAsc"] = "EXPIRES_AT_ASC";
    OrganizationInvitesOrderBy["ExpiresAtDesc"] = "EXPIRES_AT_DESC";
    OrganizationInvitesOrderBy["IdAsc"] = "ID_ASC";
    OrganizationInvitesOrderBy["IdDesc"] = "ID_DESC";
    OrganizationInvitesOrderBy["Natural"] = "NATURAL";
    OrganizationInvitesOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    OrganizationInvitesOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    OrganizationInvitesOrderBy["PermissionsAsc"] = "PERMISSIONS_ASC";
    OrganizationInvitesOrderBy["PermissionsDesc"] = "PERMISSIONS_DESC";
    OrganizationInvitesOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    OrganizationInvitesOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    OrganizationInvitesOrderBy["RedeemedAtAsc"] = "REDEEMED_AT_ASC";
    OrganizationInvitesOrderBy["RedeemedAtDesc"] = "REDEEMED_AT_DESC";
    OrganizationInvitesOrderBy["RedeemedByAsc"] = "REDEEMED_BY_ASC";
    OrganizationInvitesOrderBy["RedeemedByDesc"] = "REDEEMED_BY_DESC";
    OrganizationInvitesOrderBy["RoleAsc"] = "ROLE_ASC";
    OrganizationInvitesOrderBy["RoleDesc"] = "ROLE_DESC";
    OrganizationInvitesOrderBy["TokenAsc"] = "TOKEN_ASC";
    OrganizationInvitesOrderBy["TokenDesc"] = "TOKEN_DESC";
    OrganizationInvitesOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    OrganizationInvitesOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(OrganizationInvitesOrderBy || (OrganizationInvitesOrderBy = {}));
/** Methods to use when ordering `OrganizationMember`. */
export var OrganizationMembersOrderBy;
(function (OrganizationMembersOrderBy) {
    OrganizationMembersOrderBy["CanWriteAssetsAsc"] = "CAN_WRITE_ASSETS_ASC";
    OrganizationMembersOrderBy["CanWriteAssetsDesc"] = "CAN_WRITE_ASSETS_DESC";
    OrganizationMembersOrderBy["CanWriteInvitesAsc"] = "CAN_WRITE_INVITES_ASC";
    OrganizationMembersOrderBy["CanWriteInvitesDesc"] = "CAN_WRITE_INVITES_DESC";
    OrganizationMembersOrderBy["CanWriteMembersAsc"] = "CAN_WRITE_MEMBERS_ASC";
    OrganizationMembersOrderBy["CanWriteMembersDesc"] = "CAN_WRITE_MEMBERS_DESC";
    OrganizationMembersOrderBy["CanWriteOfferingsAsc"] = "CAN_WRITE_OFFERINGS_ASC";
    OrganizationMembersOrderBy["CanWriteOfferingsDesc"] = "CAN_WRITE_OFFERINGS_DESC";
    OrganizationMembersOrderBy["CanWriteOrganizationAsc"] = "CAN_WRITE_ORGANIZATION_ASC";
    OrganizationMembersOrderBy["CanWriteOrganizationDesc"] = "CAN_WRITE_ORGANIZATION_DESC";
    OrganizationMembersOrderBy["CanWriteProjectsAsc"] = "CAN_WRITE_PROJECTS_ASC";
    OrganizationMembersOrderBy["CanWriteProjectsDesc"] = "CAN_WRITE_PROJECTS_DESC";
    OrganizationMembersOrderBy["CanWriteSessionsAsc"] = "CAN_WRITE_SESSIONS_ASC";
    OrganizationMembersOrderBy["CanWriteSessionsDesc"] = "CAN_WRITE_SESSIONS_DESC";
    OrganizationMembersOrderBy["CanWriteTemplatesAsc"] = "CAN_WRITE_TEMPLATES_ASC";
    OrganizationMembersOrderBy["CanWriteTemplatesDesc"] = "CAN_WRITE_TEMPLATES_DESC";
    OrganizationMembersOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    OrganizationMembersOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    OrganizationMembersOrderBy["InvitedAtAsc"] = "INVITED_AT_ASC";
    OrganizationMembersOrderBy["InvitedAtDesc"] = "INVITED_AT_DESC";
    OrganizationMembersOrderBy["InvitedByUserIdAsc"] = "INVITED_BY_USER_ID_ASC";
    OrganizationMembersOrderBy["InvitedByUserIdDesc"] = "INVITED_BY_USER_ID_DESC";
    OrganizationMembersOrderBy["JoinedAtAsc"] = "JOINED_AT_ASC";
    OrganizationMembersOrderBy["JoinedAtDesc"] = "JOINED_AT_DESC";
    OrganizationMembersOrderBy["Natural"] = "NATURAL";
    OrganizationMembersOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    OrganizationMembersOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    OrganizationMembersOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    OrganizationMembersOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    OrganizationMembersOrderBy["RoleAsc"] = "ROLE_ASC";
    OrganizationMembersOrderBy["RoleDesc"] = "ROLE_DESC";
    OrganizationMembersOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    OrganizationMembersOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    OrganizationMembersOrderBy["UserIdAsc"] = "USER_ID_ASC";
    OrganizationMembersOrderBy["UserIdDesc"] = "USER_ID_DESC";
})(OrganizationMembersOrderBy || (OrganizationMembersOrderBy = {}));
/** Methods to use when ordering `Organization`. */
export var OrganizationsOrderBy;
(function (OrganizationsOrderBy) {
    OrganizationsOrderBy["AccessStatusAsc"] = "ACCESS_STATUS_ASC";
    OrganizationsOrderBy["AccessStatusDesc"] = "ACCESS_STATUS_DESC";
    OrganizationsOrderBy["AllowMemberInvitesAsc"] = "ALLOW_MEMBER_INVITES_ASC";
    OrganizationsOrderBy["AllowMemberInvitesDesc"] = "ALLOW_MEMBER_INVITES_DESC";
    OrganizationsOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    OrganizationsOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    OrganizationsOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    OrganizationsOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    OrganizationsOrderBy["AvatarUrlAsc"] = "AVATAR_URL_ASC";
    OrganizationsOrderBy["AvatarUrlDesc"] = "AVATAR_URL_DESC";
    OrganizationsOrderBy["ContextAsc"] = "CONTEXT_ASC";
    OrganizationsOrderBy["ContextDesc"] = "CONTEXT_DESC";
    OrganizationsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    OrganizationsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    OrganizationsOrderBy["DefaultProjectVisibilityAsc"] = "DEFAULT_PROJECT_VISIBILITY_ASC";
    OrganizationsOrderBy["DefaultProjectVisibilityDesc"] = "DEFAULT_PROJECT_VISIBILITY_DESC";
    OrganizationsOrderBy["DescriptionAsc"] = "DESCRIPTION_ASC";
    OrganizationsOrderBy["DescriptionDesc"] = "DESCRIPTION_DESC";
    OrganizationsOrderBy["IconFileUrlAsc"] = "ICON_FILE_URL_ASC";
    OrganizationsOrderBy["IconFileUrlDesc"] = "ICON_FILE_URL_DESC";
    OrganizationsOrderBy["IdAsc"] = "ID_ASC";
    OrganizationsOrderBy["IdDesc"] = "ID_DESC";
    OrganizationsOrderBy["LogoFileUrlAsc"] = "LOGO_FILE_URL_ASC";
    OrganizationsOrderBy["LogoFileUrlDesc"] = "LOGO_FILE_URL_DESC";
    OrganizationsOrderBy["NameAsc"] = "NAME_ASC";
    OrganizationsOrderBy["NameDesc"] = "NAME_DESC";
    OrganizationsOrderBy["Natural"] = "NATURAL";
    OrganizationsOrderBy["OnboardingStatusAsc"] = "ONBOARDING_STATUS_ASC";
    OrganizationsOrderBy["OnboardingStatusDesc"] = "ONBOARDING_STATUS_DESC";
    OrganizationsOrderBy["OwnerIdAsc"] = "OWNER_ID_ASC";
    OrganizationsOrderBy["OwnerIdDesc"] = "OWNER_ID_DESC";
    OrganizationsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    OrganizationsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    OrganizationsOrderBy["SlugAsc"] = "SLUG_ASC";
    OrganizationsOrderBy["SlugDesc"] = "SLUG_DESC";
    OrganizationsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    OrganizationsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(OrganizationsOrderBy || (OrganizationsOrderBy = {}));
/** Methods to use when ordering `ParticipantProfile`. */
export var ParticipantProfilesOrderBy;
(function (ParticipantProfilesOrderBy) {
    ParticipantProfilesOrderBy["AvatarUrlAsc"] = "AVATAR_URL_ASC";
    ParticipantProfilesOrderBy["AvatarUrlDesc"] = "AVATAR_URL_DESC";
    ParticipantProfilesOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ParticipantProfilesOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ParticipantProfilesOrderBy["EmailAsc"] = "EMAIL_ASC";
    ParticipantProfilesOrderBy["EmailDesc"] = "EMAIL_DESC";
    ParticipantProfilesOrderBy["FirstNameAsc"] = "FIRST_NAME_ASC";
    ParticipantProfilesOrderBy["FirstNameDesc"] = "FIRST_NAME_DESC";
    ParticipantProfilesOrderBy["IdAsc"] = "ID_ASC";
    ParticipantProfilesOrderBy["IdDesc"] = "ID_DESC";
    ParticipantProfilesOrderBy["LastNameAsc"] = "LAST_NAME_ASC";
    ParticipantProfilesOrderBy["LastNameDesc"] = "LAST_NAME_DESC";
    ParticipantProfilesOrderBy["MetadataAsc"] = "METADATA_ASC";
    ParticipantProfilesOrderBy["MetadataDesc"] = "METADATA_DESC";
    ParticipantProfilesOrderBy["Natural"] = "NATURAL";
    ParticipantProfilesOrderBy["OrganizationDomainAsc"] = "ORGANIZATION_DOMAIN_ASC";
    ParticipantProfilesOrderBy["OrganizationDomainDesc"] = "ORGANIZATION_DOMAIN_DESC";
    ParticipantProfilesOrderBy["OrganizationNameAsc"] = "ORGANIZATION_NAME_ASC";
    ParticipantProfilesOrderBy["OrganizationNameDesc"] = "ORGANIZATION_NAME_DESC";
    ParticipantProfilesOrderBy["ParticipantIdAsc"] = "PARTICIPANT_ID_ASC";
    ParticipantProfilesOrderBy["ParticipantIdDesc"] = "PARTICIPANT_ID_DESC";
    ParticipantProfilesOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ParticipantProfilesOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ParticipantProfilesOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ParticipantProfilesOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(ParticipantProfilesOrderBy || (ParticipantProfilesOrderBy = {}));
/** Methods to use when ordering `Participant`. */
export var ParticipantsOrderBy;
(function (ParticipantsOrderBy) {
    ParticipantsOrderBy["AgentIdAsc"] = "AGENT_ID_ASC";
    ParticipantsOrderBy["AgentIdDesc"] = "AGENT_ID_DESC";
    ParticipantsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ParticipantsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ParticipantsOrderBy["ExternalIdAsc"] = "EXTERNAL_ID_ASC";
    ParticipantsOrderBy["ExternalIdDesc"] = "EXTERNAL_ID_DESC";
    ParticipantsOrderBy["IdAsc"] = "ID_ASC";
    ParticipantsOrderBy["IdDesc"] = "ID_DESC";
    ParticipantsOrderBy["Natural"] = "NATURAL";
    ParticipantsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ParticipantsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ParticipantsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ParticipantsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ParticipantsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ParticipantsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(ParticipantsOrderBy || (ParticipantsOrderBy = {}));
/** Methods to use when ordering `Profile`. */
export var ProfilesOrderBy;
(function (ProfilesOrderBy) {
    ProfilesOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    ProfilesOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    ProfilesOrderBy["AvatarImageUrlAsc"] = "AVATAR_IMAGE_URL_ASC";
    ProfilesOrderBy["AvatarImageUrlDesc"] = "AVATAR_IMAGE_URL_DESC";
    ProfilesOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ProfilesOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ProfilesOrderBy["EmailAsc"] = "EMAIL_ASC";
    ProfilesOrderBy["EmailDesc"] = "EMAIL_DESC";
    ProfilesOrderBy["FirstNameAsc"] = "FIRST_NAME_ASC";
    ProfilesOrderBy["FirstNameDesc"] = "FIRST_NAME_DESC";
    ProfilesOrderBy["IdAsc"] = "ID_ASC";
    ProfilesOrderBy["IdDesc"] = "ID_DESC";
    ProfilesOrderBy["LastNameAsc"] = "LAST_NAME_ASC";
    ProfilesOrderBy["LastNameDesc"] = "LAST_NAME_DESC";
    ProfilesOrderBy["Natural"] = "NATURAL";
    ProfilesOrderBy["OrganizationDomainAsc"] = "ORGANIZATION_DOMAIN_ASC";
    ProfilesOrderBy["OrganizationDomainDesc"] = "ORGANIZATION_DOMAIN_DESC";
    ProfilesOrderBy["OrganizationNameAsc"] = "ORGANIZATION_NAME_ASC";
    ProfilesOrderBy["OrganizationNameDesc"] = "ORGANIZATION_NAME_DESC";
    ProfilesOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ProfilesOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ProfilesOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ProfilesOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    ProfilesOrderBy["UserIdAsc"] = "USER_ID_ASC";
    ProfilesOrderBy["UserIdDesc"] = "USER_ID_DESC";
})(ProfilesOrderBy || (ProfilesOrderBy = {}));
/** Methods to use when ordering `ProjectOffering`. */
export var ProjectOfferingsOrderBy;
(function (ProjectOfferingsOrderBy) {
    ProjectOfferingsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ProjectOfferingsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ProjectOfferingsOrderBy["Natural"] = "NATURAL";
    ProjectOfferingsOrderBy["OfferingIdAsc"] = "OFFERING_ID_ASC";
    ProjectOfferingsOrderBy["OfferingIdDesc"] = "OFFERING_ID_DESC";
    ProjectOfferingsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ProjectOfferingsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ProjectOfferingsOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    ProjectOfferingsOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
})(ProjectOfferingsOrderBy || (ProjectOfferingsOrderBy = {}));
/** Methods to use when ordering `Project`. */
export var ProjectsOrderBy;
(function (ProjectsOrderBy) {
    ProjectsOrderBy["AllowExternalSharesAsc"] = "ALLOW_EXTERNAL_SHARES_ASC";
    ProjectsOrderBy["AllowExternalSharesDesc"] = "ALLOW_EXTERNAL_SHARES_DESC";
    ProjectsOrderBy["ColorAsc"] = "COLOR_ASC";
    ProjectsOrderBy["ColorDesc"] = "COLOR_DESC";
    ProjectsOrderBy["ContextAsc"] = "CONTEXT_ASC";
    ProjectsOrderBy["ContextDesc"] = "CONTEXT_DESC";
    ProjectsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ProjectsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ProjectsOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    ProjectsOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    ProjectsOrderBy["DescriptionAsc"] = "DESCRIPTION_ASC";
    ProjectsOrderBy["DescriptionDesc"] = "DESCRIPTION_DESC";
    ProjectsOrderBy["IdAsc"] = "ID_ASC";
    ProjectsOrderBy["IdDesc"] = "ID_DESC";
    ProjectsOrderBy["NameAsc"] = "NAME_ASC";
    ProjectsOrderBy["NameDesc"] = "NAME_DESC";
    ProjectsOrderBy["Natural"] = "NATURAL";
    ProjectsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ProjectsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ProjectsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ProjectsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ProjectsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ProjectsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    ProjectsOrderBy["VisibilityAsc"] = "VISIBILITY_ASC";
    ProjectsOrderBy["VisibilityDesc"] = "VISIBILITY_DESC";
})(ProjectsOrderBy || (ProjectsOrderBy = {}));
/** Methods to use when ordering `ShareableLink`. */
export var ShareableLinksOrderBy;
(function (ShareableLinksOrderBy) {
    ShareableLinksOrderBy["AccessTypeAsc"] = "ACCESS_TYPE_ASC";
    ShareableLinksOrderBy["AccessTypeDesc"] = "ACCESS_TYPE_DESC";
    ShareableLinksOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    ShareableLinksOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    ShareableLinksOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    ShareableLinksOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    ShareableLinksOrderBy["AssetIdAsc"] = "ASSET_ID_ASC";
    ShareableLinksOrderBy["AssetIdDesc"] = "ASSET_ID_DESC";
    ShareableLinksOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ShareableLinksOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ShareableLinksOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    ShareableLinksOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    ShareableLinksOrderBy["ExpiresAtAsc"] = "EXPIRES_AT_ASC";
    ShareableLinksOrderBy["ExpiresAtDesc"] = "EXPIRES_AT_DESC";
    ShareableLinksOrderBy["LastAccessedAtAsc"] = "LAST_ACCESSED_AT_ASC";
    ShareableLinksOrderBy["LastAccessedAtDesc"] = "LAST_ACCESSED_AT_DESC";
    ShareableLinksOrderBy["Natural"] = "NATURAL";
    ShareableLinksOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ShareableLinksOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ShareableLinksOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ShareableLinksOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ShareableLinksOrderBy["TargetUserIdAsc"] = "TARGET_USER_ID_ASC";
    ShareableLinksOrderBy["TargetUserIdDesc"] = "TARGET_USER_ID_DESC";
    ShareableLinksOrderBy["TokenAsc"] = "TOKEN_ASC";
    ShareableLinksOrderBy["TokenDesc"] = "TOKEN_DESC";
    ShareableLinksOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ShareableLinksOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    ShareableLinksOrderBy["ViewCountAsc"] = "VIEW_COUNT_ASC";
    ShareableLinksOrderBy["ViewCountDesc"] = "VIEW_COUNT_DESC";
})(ShareableLinksOrderBy || (ShareableLinksOrderBy = {}));
/** Methods to use when ordering `ShortLink`. */
export var ShortLinksOrderBy;
(function (ShortLinksOrderBy) {
    ShortLinksOrderBy["ArchivedAtAsc"] = "ARCHIVED_AT_ASC";
    ShortLinksOrderBy["ArchivedAtDesc"] = "ARCHIVED_AT_DESC";
    ShortLinksOrderBy["ArchivedByUserIdAsc"] = "ARCHIVED_BY_USER_ID_ASC";
    ShortLinksOrderBy["ArchivedByUserIdDesc"] = "ARCHIVED_BY_USER_ID_DESC";
    ShortLinksOrderBy["ConnectionCodeAsc"] = "CONNECTION_CODE_ASC";
    ShortLinksOrderBy["ConnectionCodeDesc"] = "CONNECTION_CODE_DESC";
    ShortLinksOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    ShortLinksOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    ShortLinksOrderBy["CreatedByUserIdAsc"] = "CREATED_BY_USER_ID_ASC";
    ShortLinksOrderBy["CreatedByUserIdDesc"] = "CREATED_BY_USER_ID_DESC";
    ShortLinksOrderBy["DomainAsc"] = "DOMAIN_ASC";
    ShortLinksOrderBy["DomainDesc"] = "DOMAIN_DESC";
    ShortLinksOrderBy["ExpiresAtAsc"] = "EXPIRES_AT_ASC";
    ShortLinksOrderBy["ExpiresAtDesc"] = "EXPIRES_AT_DESC";
    ShortLinksOrderBy["IdAsc"] = "ID_ASC";
    ShortLinksOrderBy["IdDesc"] = "ID_DESC";
    ShortLinksOrderBy["Natural"] = "NATURAL";
    ShortLinksOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    ShortLinksOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    ShortLinksOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    ShortLinksOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    ShortLinksOrderBy["ProjectIdAsc"] = "PROJECT_ID_ASC";
    ShortLinksOrderBy["ProjectIdDesc"] = "PROJECT_ID_DESC";
    ShortLinksOrderBy["QueryParamsAsc"] = "QUERY_PARAMS_ASC";
    ShortLinksOrderBy["QueryParamsDesc"] = "QUERY_PARAMS_DESC";
    ShortLinksOrderBy["SlugAsc"] = "SLUG_ASC";
    ShortLinksOrderBy["SlugDesc"] = "SLUG_DESC";
    ShortLinksOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ShortLinksOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(ShortLinksOrderBy || (ShortLinksOrderBy = {}));
/** Methods to use when ordering `Subscription`. */
export var SubscriptionsOrderBy;
(function (SubscriptionsOrderBy) {
    SubscriptionsOrderBy["CancelAtPeriodEndAsc"] = "CANCEL_AT_PERIOD_END_ASC";
    SubscriptionsOrderBy["CancelAtPeriodEndDesc"] = "CANCEL_AT_PERIOD_END_DESC";
    SubscriptionsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    SubscriptionsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    SubscriptionsOrderBy["CurrentPeriodEndAsc"] = "CURRENT_PERIOD_END_ASC";
    SubscriptionsOrderBy["CurrentPeriodEndDesc"] = "CURRENT_PERIOD_END_DESC";
    SubscriptionsOrderBy["CurrentPeriodStartAsc"] = "CURRENT_PERIOD_START_ASC";
    SubscriptionsOrderBy["CurrentPeriodStartDesc"] = "CURRENT_PERIOD_START_DESC";
    SubscriptionsOrderBy["IdAsc"] = "ID_ASC";
    SubscriptionsOrderBy["IdDesc"] = "ID_DESC";
    SubscriptionsOrderBy["MetadataAsc"] = "METADATA_ASC";
    SubscriptionsOrderBy["MetadataDesc"] = "METADATA_DESC";
    SubscriptionsOrderBy["Natural"] = "NATURAL";
    SubscriptionsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    SubscriptionsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    SubscriptionsOrderBy["PaymentProviderAsc"] = "PAYMENT_PROVIDER_ASC";
    SubscriptionsOrderBy["PaymentProviderDesc"] = "PAYMENT_PROVIDER_DESC";
    SubscriptionsOrderBy["PlanTypeAsc"] = "PLAN_TYPE_ASC";
    SubscriptionsOrderBy["PlanTypeDesc"] = "PLAN_TYPE_DESC";
    SubscriptionsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    SubscriptionsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    SubscriptionsOrderBy["RemoteCustomerIdAsc"] = "REMOTE_CUSTOMER_ID_ASC";
    SubscriptionsOrderBy["RemoteCustomerIdDesc"] = "REMOTE_CUSTOMER_ID_DESC";
    SubscriptionsOrderBy["RemoteSubscriptionIdAsc"] = "REMOTE_SUBSCRIPTION_ID_ASC";
    SubscriptionsOrderBy["RemoteSubscriptionIdDesc"] = "REMOTE_SUBSCRIPTION_ID_DESC";
    SubscriptionsOrderBy["StatusAsc"] = "STATUS_ASC";
    SubscriptionsOrderBy["StatusDesc"] = "STATUS_DESC";
    SubscriptionsOrderBy["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    SubscriptionsOrderBy["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(SubscriptionsOrderBy || (SubscriptionsOrderBy = {}));
